import { useMemo } from 'react';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  total_employee: number;
  overtime_percent: number;
  no_overtime_percent: number;
}

export const useStaffByOvertimePercent = (): ChartProps => {
  const { t } = useLang();

  const { list } = useDashboardStore();
  const data = list?.overtime_percent as DataType;

  const chartData = useMemo<Partial<ChartProps>>(() => {
    if (data) {
      const series = [data.overtime_percent, data.no_overtime_percent];

      return {
        series,
        options: {
          chart: {
            type: 'donut',
            toolbar: { show: false },
          },
          labels: [t('Перерабатывают'), t('Не перерабатывают')],
          legend: {
            position: 'right',
            formatter: (label, { seriesIndex }) => {
              const value = series[seriesIndex];
              return `${label} - ${value}%`;
            },
            fontSize: '14px',
            fontWeight: 400,
          },
          dataLabels: {
            enabled: true,
            formatter: (val: number) => `${val}%`,
            style: {
              fontSize: '16px',
              fontWeight: 'bold',
            },
          },
          plotOptions: {
            pie: {
              donut: {
                size: '75%',
                labels: {
                  show: true,
                  name: {
                    show: true,
                    offsetY: 10,
                    formatter: () => t('сотрудника', { number: data.total_employee }),
                    fontSize: '18px',
                    fontWeight: 'bold',
                  },
                  value: {
                    show: false,
                  },
                  total: {
                    show: false,
                  },
                },
              },
            },
          },
          tooltip: {
            enabled: true,
            y: {
              formatter: (val: number) => `${val}%`,
            },
          },
          colors: ['#4CAF50', '#D32F2F'],
        },
      };
    }

    return { series: [], options: {} };
  }, [data, t]);

  return {
    label: 'Процент сотрудников с переработками',
    type: 'donut',
    wrapped: true,
    series: chartData.series,
    options: chartData.options,
  };
};
